<div class="location-warehouse-app__header p-6">
  <h1 class="mat-h2 font-bold">Transfer Sku(s)</h1>
</div>
<div class="p-6" [formGroup]="form">
  <div class="flex justify-content-end mb-4">
    <button
      class="lum-button w-100"
      [disabled]="
        !formValues?.sourceLocations?.length ||
        !locationFormControlValue ||
        form.invalid ||
        submitLoading
      "
      (click)="onTransfer(form.value)"
    >
      Transfer
      <i *ngIf="submitLoading" class="ml-2 fas fa-spinner fa-spin"></i>
    </button>
  </div>
  <div class="mb-4">
    <div class="lum-label">
      Location: This action will move the selected skus to the selected location.
    </div>
    <lum-ui-autocomplete
      [options]="locations"
      [debounceTime]="500"
      [placeholder]="'Search Location...'"
      [loading]="loading"
      [displayProperty]="'locationDisplay'"
      (inputChangeEvent)="onChangeEvent($event)"
      (optionSelectedEvent)="onSelectEvent($event)"
      class="input-box"
    ></lum-ui-autocomplete>
  </div>

  <ng-container *ngIf="formValues?.sourceLocations?.length; else empty">
    <table class="lum-table lum-table--classic striped">
      <tr>
        <th class="w-p35">Warehouse Name</th>
        <th class="w-p15">Location</th>
        <th class="w-p20">Lot #</th>
        <th class="w-p10">Production Date</th>
        <th class="w-p10">Onhand Qty.</th>
        <th class="w-p10">Quantity</th>
      </tr>
      <tbody formArrayName="sourceLocations">
        <ng-container
          *ngFor="let item of warehousesFormArray?.controls; let i = index"
        >
          <tr [formGroupName]="i" [class.error-row]="item.invalid">
            <td>{{ item?.value?.warehouseName }}</td>
            <td>{{ item?.value?.location }}</td>
            <td>{{ item?.value?.lotNumber }}</td>
            <td>{{ item?.value?.productionDate }}</td>
            <td>{{ item?.value?.onhandQty }}</td>
            <td>
              <input type="number" class="lum-input" formControlName="quantity" />
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </ng-container>
</div>

<ng-template #empty>
  <lum-ui-empty-page
    title="There are no Automation Rules to show"
  ></lum-ui-empty-page>
</ng-template>
